import { LitElement, html, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import type { ButtonOption } from '../../services/types.js';
import styles from '../../styles/mariana-csat-buttons.css?inline';

/**
 * CSAT Buttons Component
 * Renders a 1–10 grid of numbered cubes for customer satisfaction rating
 */
@customElement('mariana-csat-buttons')
export class MarianaCsatButtons extends LitElement {
    static readonly styles = unsafeCSS(styles);

    @property({ type: Array })
    buttons: ButtonOption[] = [];

    private handleClick(button: ButtonOption) {
        this.dispatchEvent(new CustomEvent('button-click', {
            detail: button,
            bubbles: true,
            composed: true,
        }));
    }

    render() {
        if (!this.buttons || this.buttons.length === 0) {
            return html``;
        }

        return html`
      <div class="csat-container">
        ${this.buttons.map((button) => html`
          <button
            class="csat-button"
            @click=${() => this.handleClick(button)}
            type="button"
          >
            ${button.label}
          </button>
        `)}
      </div>
    `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'mariana-csat-buttons': MarianaCsatButtons;
    }
}
